<template>
  <div class="_main">
    <div class="_top">
      <el-button type="primary" size="medium" @click="addNewWorkClick()" plain
        >+ 新增工作项</el-button
      >
    </div>
    <div class="_table">
      <div class="_left">
        <!--  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"> -->
        <el-table
          ref="leftTable"
          class="hide-table-header-border"
          :data="workDataLeft"
          height="100%"
          :header-cell-style="{ color: '#000000', border: 0 + 'px' }"
          :cell-style="{ border: 0 + 'px' }"
        >
          <el-table-column prop="itemName" label="工作项"> </el-table-column>
          <el-table-column prop="children" label="规格">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.children" :key="index">
                {{ item.itemName }}
                <span v-if="index < scope.row.children.length - 1">、</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="itemUnitName" label="计量单位" width="100">
          </el-table-column>
          <el-table-column prop="" label="" width="90">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                class="hiddenBtn"
                @click="editClick(scope.row)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                class="hiddenBtn"
                @click="deleteClick(scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="_right">
        <el-table
          ref="rightTable"
          class="hide-table-header-border"
          :data="workDataRight"
          height="100%"
          :header-cell-style="{ color: '#000000', border: 0 + 'px' }"
          :cell-style="{ border: 0 + 'px' }"
        >
          <el-table-column prop="itemName" label="工作项"> </el-table-column>
          
          <el-table-column prop="itemUnitName" label="计量单位" width="100">
          </el-table-column>
          <el-table-column prop="" label="" width="90">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                class="hiddenBtn"
                @click="editClick(scope.row)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                class="hiddenBtn"
                @click="deleteClick(scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="删除"
      :visible.sync="deleteDialog"
      width="30%"
      align-center
      class="centered-dialog"
    >
      <span class="_info">{{ delInfo }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="ensureDelete()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="30%"
      class="centered-dialog"
      align-center
    >
      <el-form
        :model="postParams"
        label-width="100px"
        :rules="rules"
        ref="workForm"
      >
        <el-form-item label="工作项：" prop="itemName">
          <el-input
            v-model="postParams.itemName"
            placeholder="请填写工作项"
          ></el-input>
        </el-form-item>
        <el-form-item label="计量单位：" prop="itemUnit">
          <el-select
            v-model="postParams.itemUnit"
            placeholder="请选择计量单位"
            style="width: 55%"
          >
            <el-option
              v-for="item in unitList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格：" v-if="dialogTitle !== '新增工作项'">
          <div v-for="(item, index) in postParams.children" :key="index" style="margin-bottom: 10px;">
            <el-input
              v-model="item.itemName"
              placeholder="请填写规格名称"
              style="width: 40%; margin-right: 10px;"
              :disabled="editingChildId !== item.id"
            ></el-input>
            <el-select
              v-model="item.itemUnitName"
              placeholder="请选择计量单位"
              style="width: 30%; margin-right: 10px;"
              :disabled="editingChildId !== item.id"
            >
              <el-option
                v-for="unit in unitList"
                :key="unit.dictValue"
                :label="unit.dictName"
                :value="unit.dictValue"
              >
              </el-option>
            </el-select>
            <el-button 
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="checkChild(item.id)"
              round
            >编辑</el-button>
            <el-button v-if="editingChildId === item.id"
              type="warning"
              icon="el-icon-check"
              size="mini"
              @click="updateSpec(item.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeChild(item.id)"
              circle
            ></el-button>
          </div>
          <div v-if="newSpecDialog" style="margin-bottom: 10px">
            <el-input
              v-model="childrenPostParams.itemName"
              placeholder="请填写规格名称"
              style="width: 40%; margin-right: 10px"
            ></el-input>
            <el-select
              v-model="childrenPostParams.itemUnit"
              placeholder="请选择计量单位"
              style="width: 30%; margin-right: 10px"
            >
              <el-option
                v-for="unit in unitList"
                :key="unit.dictValue"
                :label="unit.dictName"
                :value="unit.dictValue"
              >
              </el-option>
            </el-select>
            <el-button
              type="warning"
              icon="el-icon-check"
              size="mini"
              @click="confirmSpec()"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeSpec()"
              circle
            ></el-button>
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="newSpecDialog =true"
            plain
            >添加规格</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="ensureBtnFunc('workForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDictList } from "@/api/pServer/staff";
import LibraryPost from "../../api/pServer/library";
export default {
  data() {
    return {
      newSpecDialog: false,
      workDataLeft: [],
      workDataRight: [],
      deleteDialog: false,
      delInfo: "",
      showDialog: false,
      unitList: [],
      unitType: { dictCode: "item_unit" },
      postParams: {
        id: "",
        itemName: "",
        itemUnit: "",
        itemUnitName: "",
        workId: "",
        parentId: "",
        children: [],
      },
      childrenPostParams: {
        id: "",
        itemName: "",
        itemUnit: "",
        itemUnitName: "",
        workId: "",
        parentId: "",
        children: [],
      },
      dialogTitle: "",
      editingChildId: "",
      rules: {
        itemName: [
          { required: true, message: "请填写工作项", trigger: "blur" },
        ],
        itemUnit: [
          { required: true, message: "请选择计量单位", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    addNewWorkClick() {
      this.dialogTitle = "新增工作项";
      this.postParams = {
        id: "",
        itemName: "",
        itemUnit: "",
        itemUnitName: "",
        workId: this.postParams.workId,
      };
      this.showDialog = true;
    },
    editClick(data) {
      // this.$refs['workForm'].resetFields()
      this.dialogTitle = "修改工作项";
      // console.log('data:', data);
      let editObj = { ...data };
      this.postParams = editObj;
      this.postParams.itemUnit = editObj.itemUnit.toString();
      this.showDialog = true;
    },
    ensureBtnFunc(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle.includes("新增")) {
            this.unitList.forEach((item) => {
              if (item.dictValue == this.postParams.itemUnit) {
                this.postParams.itemUnitName = item.dictName;
              }
            });
            // 判断children[]中是否有未保存编辑的
            this.addNewWork(this.postParams);
                    this.showDialog = false;

          } else {
            // 判断children[]中是否有未保存编辑的
            this.updateWork(this.postParams);
                    this.showDialog = false;

          }
          // console.log('入参', this.postParams);
          this.editingChildId = "";
        } else {
          return false;
        }
      });
    },
    deleteClick(data) {
      this.delInfo = `确定删除\u00A0 ${data.itemName}  \u00A0吗？`;
      this.deleteDialog = true;
      this.postParams = data;
    },
    ensureDelete() {
      this.deleteWork(this.postParams);
        this.deleteDialog = false;
    },
    syncscroll() {
      const originTable = this.$refs.leftTable.bodyWrapper;
      const targetTable = this.$refs.rightTable.bodyWrapper;
      originTable.addEventListener("scroll", () => {
        targetTable.scrollTop = originTable.scrollTop;
        targetTable.scrollLeft = originTable.scrollLeft;
      });
      targetTable.addEventListener("scroll", () => {
        originTable.scrollTop = targetTable.scrollTop;
        originTable.scrollLeft = targetTable.scrollLeft;
      });
    },
    async queryItemByWorkId() {
      const res = await LibraryPost.queryItemByWorkId({
        workId: this.postParams.workId,
      });
      var workData = res.data.data;
      this.workDataLeft.length = 0;
      this.workDataRight.length = 0;
      for (var i = 0; i < workData.length; i++) {
        if (i % 2 == 0) {
          this.workDataLeft.push(workData[i]);
        } else {
          this.workDataRight.push(workData[i]);
        }
      }
    },
    async addNewWork(params) {
      delete params.id;
      const res = await LibraryPost.saveNewWorkinfo(params);
      console.log(res,"res");
      
      if (res.data.code == 200) {
        this.queryItemByWorkId();
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },
    async updateWork(params) {
      const res = await LibraryPost.updateWorkinfo(params);
      if (res.data.code == 200) {
        this.queryItemByWorkId();
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },
    async deleteWork(params) {
      const res = await LibraryPost.deleteWorkinfo(params);
      if (res.data.code == 200) {
        this.queryItemByWorkId();
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },
    
    confirmSpec() {
      this.unitList.forEach((item) => {
        if (item.dictValue == this.childrenPostParams.itemUnit) {
          this.childrenPostParams.itemUnitName = item.dictName;
        }
      });
      this.childrenPostParams.workId= this.postParams.workId,
      this.childrenPostParams.parentId = this.postParams.id;
      this.addNewWork(this.childrenPostParams);
      this.postParams.children.push(this.childrenPostParams);
      this.newSpecDialog = false;
      this.childrenPostParams = {
        id: "",
        itemName: "",
        itemUnit: "",
        itemUnitName: "",
        workId: "",
        parentId: "",
      }
      this.editingChildId = "";
    },
    removeChild(id) {
      this.deleteWork({ id: id,workId: this.postParams.workId});
      this.postParams.children = this.postParams.children.filter  ((item) => item.id != id);
    },
    checkChild(id) {
      this.editingChildId = id;
    },
    updateSpec(id) {
      this.childrenPostParams = this.postParams.children.find((item) => item.id == id);
      this.updateWork(this.childrenPostParams);
      this.editingChildId = "";
    },
    removeSpec() {
      this.childrenPostParams = {
        id: "",
        itemName: "",
        itemUnit: "",
        itemUnitName: "",
        workId: "",
        parentId: "",
      }
      this.newSpecDialog = false;
      this.editingChildId = "";
    }
  },
  mounted() {
    this.syncscroll();
  },
  created() {
    getDictList(this.unitType).then((res) => {
      this.unitList = res.data.data;
    });
    this.postParams.workId = this.$route.query.workId;
    this.queryItemByWorkId();
  },
};
</script>

<style scope>
._main {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

._top {
  display: flex;
  height: 60px;
  align-items: center;
  padding-left: 20px;
}

._table {
  height: calc(100% - 60px);
  width: 100%;
  display: flex;
}

._left,
._right {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  width: 50%;
  height: 100%;
  overflow-y: auto;
}

._left {
  border-right: 1px solid black;
}

._info {
  font-weight: 700;
  font-size: 18px;
}

/* 滚动条隐藏 */
.hide-scrollbar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

/* 对于其他浏览器，可以使用以下任一方法 */
::-webkit-scrollbar {
  display: none;
}

/* 悬浮隐藏 */
.hiddenBtn {
  display: none;
}

.el-table__body tr:hover > td .hiddenBtn {
  display: inline;
}

/* 去除table最下面横线 */
.el-table--border::after,
.el-table--group::after,
.el-table::before,
.el-table__fixed:before,
.el-table__fixed-right:before {
  background-color: transparent;
}
</style>
